import Domains from '@lcsc-ui/utils/domains';
import sendAxios from '@lcsc-ui/utils/request';

export function getSelectionProductPage(params) {
  return sendAxios({
    method: 'get',
    url: '/www/component/selection/product/page',
    baseURL: Domains.lcscWwwUrl,
    params,
  });
}

export function postSelectionCorrectionSave(params) {
  return sendAxios({
    method: 'post',
    url: '/www/component/selection/correction/save',
    baseURL: Domains.lcscWwwUrl,
    params,
  });
}

export function getSelectionPlanRelatedProducts(params) {
  return sendAxios({
    method: 'get',
    url: '/component/selection/plan/related_products',
    baseURL: Domains.lcscListUrl,
    params,
  });
}
